import Vue from 'vue';
import Vuex, { Store } from 'vuex';

import structure from './structure';
import monitoring from './monitoring';
import devices from './devices';
import books from './books';
import file from './file';
import auth from './auth';
import icons from './icons';
import topology from './topology';

import nails from './nails';

// Определяем тип для корневого state
export interface RootState {
  auth?: any
  books?: any
  devices?: any
  services?: any
  icons?: any
  monitoring?: any
  structure?: any
  topology?: any
  nails?: any
}

Vue.use(Vuex);

// Типизация для хуков (если нужны)
const stateFilter = (mutation: any): void => {
  console.log('MUTATION', mutation);
};

const stateReducer = (smth: any): void => {
  console.log('REDUCER', smth);
};

const store = new Vuex.Store<RootState>({
  modules: {
    structure,
    monitoring,
    devices,
    books,
    file,
    auth,
    icons,
    topology,
    nails,
  },
});

// Экспортируем store с типом
export default store;

// Опционально: экспортируем тип store для использования в компонентах
export type AppStore = typeof store;